module.exports = __webpack_public_path__ + "img/logo_memberShip.d29be70c.png";